export default "__VITE_ASSET__e2722947__"